import React from 'react'
import classNames from 'classnames'
import Star from './star.svg'
import Offline from './offline.svg'
import MessageButton from '../MessageButton'
import styles from './styles.css'

interface StatusProps {
  expertId: string
  totalReviews: number | null
  averageRating?: number | null
  acceptingNewRequests: boolean | null
  suppressReviewsAndFeed: boolean | null
  className?: string
}

const Status: React.SFC<StatusProps> = ({
  expertId,
  totalReviews,
  averageRating,
  acceptingNewRequests,
  className,
  suppressReviewsAndFeed
}) => {
  return (
    <div className={classNames(styles.status, className)}>
      {!suppressReviewsAndFeed &&
        totalReviews && (
          <div className={styles.reviews}>
            <Star className={styles.starIcon} />
            <div className={styles.label}>
              {totalReviews} reviews
              {averageRating ? ` averaging ${averageRating.toFixed(1)} stars` : null}
            </div>
          </div>
        )}

      <div className={styles.presence}>
        {acceptingNewRequests ? (
          <>
            <div className={styles.presenceIndicator}>
              <span className={styles.online} />
            </div>{' '}
            <div className={styles.label}>
              Currently online{' '}
              <MessageButton expertId={expertId} acceptingNewRequests={acceptingNewRequests}>
                Message
              </MessageButton>
            </div>
          </>
        ) : (
          <>
            <div className={styles.presenceIndicator}>
              <Offline />
            </div>{' '}
            <div className={styles.label}>Currently offline</div>
          </>
        )}
      </div>
    </div>
  )
}

export default Status
